import { Component, Input, OnInit } from '@angular/core';
import { EventEmitterTimesheetBo } from '../timesheet/timesheet.model';
import { EventEmitterTicketsBo, TicketsBO } from './ticket.model';

@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.scss']
})
export class TicketComponent implements OnInit {


  TicketsVieworEntry: boolean = false;
   @Input() clientTab!: string; 

  constructor() { }

  ngOnInit(): void {
  }

  isListorUpdateView: EventEmitterTicketsBo = {
    isEntry: false,
    tickets: new TicketsBO(),
    isEdit :false

  };
  EmitChildComponent(event: EventEmitterTicketsBo) {
    this.TicketsVieworEntry = event.isEntry;
    this.isListorUpdateView = event;
  }


}
